module.exports = __webpack_public_path__ + "img/csr_swiper_03_mobile.4528874c.jpg";